import { render, staticRenderFns } from "./stuContrast.vue?vue&type=template&id=09b26e94&scoped=true"
import script from "./stuContrast.vue?vue&type=script&lang=js"
export * from "./stuContrast.vue?vue&type=script&lang=js"
import style0 from "./stuContrast.vue?vue&type=style&index=0&id=09b26e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b26e94",
  null
  
)

export default component.exports